import { atom } from "recoil";
import { IBusLicensePermitType } from "../types";

export const addStateBusLicensePermitType = atom({
  key: "addStateBusLicensePermitType",
  default: false,
});
export const editStateBusLicensePermitType = atom({
  key: "editStateBusLicensePermitType",
  default: false,
});
export const rowEditBusLicensePermitType = atom<
  IBusLicensePermitType | undefined
>({
  key: "rowEditBusLicensePermitType",
  default: undefined,
});

export const selectedRowsStateBusLicensePermitType = atom<
  IBusLicensePermitType[]
>({
  key: "selectedRowsStateBusLicensePermitType",
  default: [],
});

export const busLicensePermitTypeFilterText = atom({
  key: "busLicensePermitTypeFilterText",
  default: "",
});

export const savingBusLicensePermitType = atom({
  key: "savingBusLicensePermitType",
  default: false,
});
export const busLicensePermitTypeFetching = atom({
  key: "busLicensePermitTypeFetching",
  default: true,
});
